 export class SubjectBilling {

subject_billing_id: number;
subject_id: any;
job_id: number;
billing_desc: string;
supplier_code: string;
amount: number;
tax_code: string;
agent_id?: number;

  }



  /*

subject_billing_id
subject_id
job_id
billing_desc
supplier_code
amount
tax_code

  */